/*
 * Какие кластеры шлют отчёты проверок безопасности в этот DefectDojo: у кластера платформы
 * аннотация viva.company.com/defectdojo-target — имя кластера инстанса (свой DefectDojo или
 * выбранный при создании кластера). Джоба app:defectdojo сервисов берёт адрес оттуда же (Vault).
 */
import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { EntityRefLink, catalogApiRef } from '@backstage/plugin-catalog-react';
import { Typography } from '@material-ui/core';
import useAsync from 'react-use/esm/useAsync';
import {
  CLUSTER_DEFECTDOJO_TARGET_ANNOTATION,
  DATASTORE_CLUSTER_ANNOTATION,
  KUBERNETES_CLUSTER_TYPE,
  annotation,
  compareByName,
} from '../../lib/viva';
import { AsyncCell } from '../catalog/cells';

export const useDefectDojoSenders = (entity: Entity) => {
  const catalogApi = useApi(catalogApiRef);
  const cluster = annotation(entity, DATASTORE_CLUSTER_ANNOTATION);
  return useAsync(async () => {
    if (!cluster) return [];
    const { items } = await catalogApi.getEntities({
      filter: {
        kind: 'Resource',
        'spec.type': KUBERNETES_CLUSTER_TYPE,
        [`metadata.annotations.${CLUSTER_DEFECTDOJO_TARGET_ANNOTATION}`]:
          cluster,
      },
      fields: ['kind', 'metadata.name', 'metadata.namespace', 'metadata.title'],
    });
    return items.sort(compareByName);
  }, [catalogApi, cluster]);
};

export const DefectDojoSenders = ({ clusters }: { clusters: Entity[] }) =>
  clusters.length ? (
    <>
      {clusters.map((c, i) => (
        <span key={c.metadata.name}>
          {i > 0 && ', '}
          <EntityRefLink entityRef={c} title={c.metadata.name} />
        </span>
      ))}
    </>
  ) : (
    <Typography variant="body2" color="textSecondary">
      —
    </Typography>
  );

export const EntityDefectDojoSendersCell = ({ entity }: { entity: Entity }) => {
  const state = useDefectDojoSenders(entity);
  return (
    <AsyncCell state={state} unavailable="Каталог недоступен">
      {clusters => <DefectDojoSenders clusters={clusters} />}
    </AsyncCell>
  );
};
